<template lang="pug">
form(@submit.prevent="onConfirm")
  modal.active(
    :active="showModal",
    @close="$router.back()",
    :title="`Verificar documento (${current.numero}/${current.ano})`"
  )
    .columns(slot="modal-body", v-if="params.ordem_servico")
      div Ao confirmar vai abir uma OS-m para verificar o Documento.
      .divider
      .form-group.column.col-12
        label.form-label
          i.fa.fa-eye.text-primary
          |
          | Selecione o tipo da verificação
        label.form-radio(v-for="item in current.verificar")
          input(
            type="radio",
            name="tipo",
            v-model="$v.params.tipo.$model",
            :value="item.tipo"
          )
          i.form-icon
          |
          | {{ tipoLabel(item.tipo) }}
          .ml-2
            div Tem verificação encerrada?: {{ item.tem_verificacao_encerrada ? "Sim" : "Não" }}
            div Dentro do prazo?:&nbsp;
              span.text-success(v-if="item.dentro_prazo") Sim
              span.text-error(v-else) Não
      form-group.column.col-12(
        label="Informe a observação da vistoria",
        :validation="$v.params.obs"
      )
        textarea.form-input(
          v-model="$v.params.obs.$model",
          rows="3",
          :disabled="$v.params.tipo.$invalid"
        )
      form-group.column.col-12(
        :label="'ordem_servico.situacao' | tModel",
        :validation="$v.params.ordem_servico.situacao"
      )
        select-ordem-servico-situacao(
          v-model="$v.params.ordem_servico.situacao.$model",
          :situacoes="allowedSituacoes"
        )
      form-group.column.col-12(
        :label="'ordem_servico.usuario_responsavel' | tModel",
        :validation="$v.params.ordem_servico.usuario_responsavel_id"
      )
        fiscal-picker(
          v-model="$v.params.ordem_servico.usuario_responsavel_id.$model"
        )
      form-group.column.col-12(
        :label="'ordem_servico.analista' | tModel",
        :validation="$v.params.ordem_servico.analista_id"
      )
        fiscal-picker(v-model="$v.params.ordem_servico.analista_id.$model")
      form-group.column.col-3.col-sm-12(
        :label="'ordem_servico.protocolo_tipo' | tModel",
        :validation="$v.params.ordem_servico.protocolo_tipo"
      )
        select-protocolo-tipo(
          v-model="$v.params.ordem_servico.protocolo_tipo.$model"
        )
      form-group.column.col-4.col-sm-12(
        v-if="params.ordem_servico.protocolo_tipo === 'sei'",
        :label="'ordem_servico.protocolo_numero' | tModel",
        :validation="$v.params.ordem_servico.protocolo_numero"
      )
        the-mask.form-input(
          v-model="$v.params.ordem_servico.protocolo_numero.$model",
          type="tel",
          mask="##.##.########/####.##",
          :masked="true"
        )
      form-group.column.col-4.col-sm-12(
        v-else,
        :label="'ordem_servico.protocolo_numero' | tModel",
        :validation="$v.params.ordem_servico.protocolo_numero"
      )
        input.form-input(
          v-model="$v.params.ordem_servico.protocolo_numero.$model"
        )
      form-group.column.col-2.col-sm-12(
        :disabled="params.ordem_servico.protocolo_tipo === 'sei'",
        label="Ano",
        :validation="$v.params.ordem_servico.protocolo_ano"
      )
        year.form-input(v-model="$v.params.ordem_servico.protocolo_ano.$model")
      form-group.column.col-3.col-sm-12(
        :label="'ordem_servico.protocolo_data' | tModel",
        :validation="$v.params.ordem_servico.protocolo_data"
      )
        datepicker(v-model="$v.params.ordem_servico.protocolo_data.$model")
      form-group.column.col-3.col-sm-12(
        :label="'ordem_servico.prazo' | tModel",
        :validation="$v.params.ordem_servico.prazo"
      )
        int.form-input(v-model="$v.params.ordem_servico.prazo.$model")

      form-group.column.col-12(:validation="$v.params.ordem_servico.agendar")
        label.form-switch
          input(
            type="checkbox",
            v-model="$v.params.ordem_servico.agendar.$model"
          )
          i.form-icon
          | É necessário agendar

    div(slot="modal-footer")
      button.btn.btn-primary(
        :disabled="$v.$invalid || loading",
        :class="{ loading }"
      )
        btn-content(name="confirm")
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors"
import { minLength, required } from "vuelidate/lib/validators"

export default {
  vuex: {
    "fiscalizacao/docs": {
      state: ["current"],
      actions: ["fetchVerificar"],
    },
  },
  data() {
    return {
      params: {
        tipo: "",
        obs: "",
        ordem_servico: {
          situacao: "andamento",
          usuario_responsavel_id: null,
          analista_id: null,
          protocolo_tipo: "geral",
          protocolo_numero: null,
          agendar: false,
          protocolo_ano: null,
          protocolo_data: "",
          prazo: 0,
        },
      },
      loading: false,
      showModal: true,
      allowedSituacoes: {
        abertura: "Em Abertura",
        andamento: "Em andamento",
        em_distribuicao: "Em distribuição",
        aguardando_distribuir: "Aguardando Distribuir",
        a_confirmar: "Aguardando Confirmar Fiscal",
      },
    }
  },
  methods: {
    async onConfirm() {
      if (this.current && this.current.exige_vistoria_pelo_mesmo_fiscal) {
        if (this.params.ordem_servico.situacao !== "a_confirmar") {
          this.params.ordem_servico.usuario_responsavel_id = null
        }
      }
      try {
        this.loading = true
        const { id } = this.current
        await this.fetchVerificar({ id, params: this.params })
        this.$toaster.success("OS-m de vistoria aberta com sucesso")
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      } finally {
        this.loading = false
      }
    },

    tipoLabel(tipo) {
      switch (tipo) {
        case "notificacao":
          return "Verificar notificação"
        case "desconto":
          return "Verificar pedido de desconto"
        case "autuacao":
          return "Verificar autuação"
        case "notificacao_sem_valor":
          return "Verificar notificação sem valor"
        case "prazo_regularizar":
          return "Verificar pedido de prazo para regularizar"
        default:
          return tipo
      }
    },
  },
  validations: {
    params: {
      tipo: { required },
      obs: {
        required,
        minLength: minLength(10),
      },
      ordem_servico: {
        situacao: {},
        usuario_responsavel_id: {},
        analista_id: {},
        protocolo_tipo: {},
        protocolo_numero: {},
        agendar: {},
        protocolo_ano: {},
        protocolo_data: {},
        prazo: {},
      },
    },
  },
  created() {
    if (this.current && this.current.verificar) {
      this.$set(this.params, "tipo", this.current.verificar[0].tipo)
      this.$set(
        this.params.ordem_servico,
        "usuario_responsavel_id",
        this.current.fiscal_id,
      )
    }
  },
}
</script>
